/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationscontentfulContentfulIntegration1 model module.
 * @module model/IntegrationscontentfulContentfulIntegration1
 * @version v0.3
 */
export default class IntegrationscontentfulContentfulIntegration1 {
  /**
   * Constructs a new <code>IntegrationscontentfulContentfulIntegration1</code>.
   * @alias module:model/IntegrationscontentfulContentfulIntegration1
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationscontentfulContentfulIntegration1</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationscontentfulContentfulIntegration1} obj Optional instance to populate.
   * @return {module:model/IntegrationscontentfulContentfulIntegration1} The populated <code>IntegrationscontentfulContentfulIntegration1</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationscontentfulContentfulIntegration1();
      if (data.hasOwnProperty('public_access_token'))
        obj.publicAccessToken = ApiClient.convertToType(data['public_access_token'], 'String');
      if (data.hasOwnProperty('space_id'))
        obj.spaceId = ApiClient.convertToType(data['space_id'], 'String');
      if (data.hasOwnProperty('api_environment'))
        obj.apiEnvironment = ApiClient.convertToType(data['api_environment'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} publicAccessToken
 */
IntegrationscontentfulContentfulIntegration1.prototype.publicAccessToken = undefined;

/**
 * @member {String} spaceId
 */
IntegrationscontentfulContentfulIntegration1.prototype.spaceId = undefined;

/**
 * @member {String} apiEnvironment
 */
IntegrationscontentfulContentfulIntegration1.prototype.apiEnvironment = undefined;

/**
 * @member {Boolean} enabled
 */
IntegrationscontentfulContentfulIntegration1.prototype.enabled = undefined;

